import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useConfigValuesState } from '../hooks/useConfigValue';
import { useLanguage } from '../_contexts/settings/settingsContext';

export const useLanguageSynchronizer = () => {
    const { i18n } = useTranslation();
    //default language retrived from the configuration endpoint
    const {
        initialData: {
            configuration: { defaultLanguage },
        },
    } = useConfigValuesState();
    //language-settings-state -> initial state is null
    const [language, setLanguage] = useLanguage();

    //change the language to the default language every time the user changes the default language
    useEffect(() => {
        i18n.changeLanguage(defaultLanguage);
    }, [defaultLanguage, i18n]);

    //set the language-settings-state to the default language once it is retrived from the configuration endpoint
    useEffect(() => {
        if (language === null) {
            setLanguage(defaultLanguage);
        }
    }, [language, defaultLanguage, setLanguage]);
};
